import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import getMergeRequestReviewersQuery from '~/sidebar/queries/get_merge_request_reviewers.query.graphql';
export default {
    name: 'SidebarReviewersInputs',
    inject: [
        'issuableIid',
        'projectPath'
    ],
    apollo: {
        issuable: {
            query: getMergeRequestReviewersQuery,
            variables () {
                return {
                    iid: this.issuableIid,
                    fullPath: this.projectPath
                };
            },
            update (data) {
                return data.namespace?.issuable;
            }
        }
    },
    data () {
        return {
            issuable: null
        };
    },
    computed: {
        reviewers () {
            return this.issuable?.reviewers?.nodes || [];
        }
    },
    methods: {
        getIdFromGraphQLId
    }
};
